import Vue from 'vue'
import API from '@/api/'
export default (link, showLoader, baseURL) => {
  let loader
  if (showLoader) {
    loader = Vue.$loading.show({
      backgroundColor: '#3498db',
      color: '#ffffff',
      opacity: 1,
      transition: 'none',
      height: 128,
      width: 128,
      loader: 'dots',
      zIndex: 300000
    })
  }
  return API(baseURL || '//panel-scannergps.com')
    .get(link).then(response => {
      if (showLoader) loader.hide()
      return response.data
    })
}



// WEBPACK FOOTER //
// ./src/api/get/index.js